<app-loading-spinner></app-loading-spinner>
<div fxFlexFill class="location-inner-reg">
    <router-outlet *ngIf="isPageAvailable"></router-outlet>
    <app-page-not-found *ngIf="!isPageAvailable"></app-page-not-found>
</div>
